export default __webpack_public_path__ + "static/media/icon-weight.4f6c9e31.svg";